import { Component, OnDestroy, OnInit } from "@angular/core";
import { getApp } from "../app";
import { WarehouseGroup } from "../../../../shared/models/warehouseGroup";

@Component({
  selector: "app-warehouse-group",
  templateUrl: "./warehouse-group.component.html",
  styleUrls: ["./warehouse-group.component.scss"],
})
export class WarehouseGroupComponent implements OnInit, OnDestroy {
  public warehouseGroups: WarehouseGroup[] = [];
  selectedFilters: { columnName: string; value: string }[] = [];
  columnsShort: string[] = [];

  app = getApp(async (app) => {
    this.app = app;
  });

  constructor() {}

  async ngOnInit(): Promise<void> {
    await this.app.warehouseGroup.getAllWarehouseGroupDocs();
    this.app.state.sortField = "warehuseGroup.warehuseGroup";
  }

  getWarehouseGroupColumns(): string[] {
    let columns = this.app.list.businessConfig.warehouseGroupColumns.map(
      (field) => field.split(".")[1]
    );
    this.columnsShort = columns.map((field) => field.split(".")[1]);

    if (this.app.users.currentUser.businessManager || this.app.auth.isAdmin) {
      columns.push("actions");
    }

    return columns;
  }

  discardChanges() {
    this.app.unlockedId = null;
  }

  ngOnDestroy(): void {}
}
